<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
	export default {
		name: 'App',
	}
</script>
<style media="print">
    @page {
        size: auto;
        margin: 5mm;
        border-collapse: collapse;
    }
</style>
<style>
    html,body{
        /*width: 100%;*/
        /*height: 100%;*/
        overflow: auto;
    }
    body::-webkit-scrollbar {
        /*display: none;*/
    }
    /*去除input框默認樣式*/
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue